import DriverChangeLog, { IDriverChange } from "../model/DriverChangeLog";
import Api from "../services/api";
import { IMultiCallParam } from "../utils/api.interfaces";
import { getServerDate } from "../utils/storage/date";

export function getDriverChangeParams(dateTime: string, deviceId?: string, userId?: string): IMultiCallParam {
    return {
        typeName: "DriverChange",
        search: {
            fromDate: dateTime,
            toDate: dateTime,
            includeOverlappedChanges: true,
            deviceSearch: deviceId ? { id: deviceId } : undefined,
            userSearch: userId ? { id: userId } : undefined
        },
        resultsLimit: 1
    };
}

export function getDriverChange(api: Api, dateTime = getServerDate().toISOString(), deviceId?: string, userId?: string) {
    return new Promise<IDriverChange[]>((resolve, reject) => {
        if (!userId && !deviceId) {
            resolve([]);
            return;
        }

        return api.callPromise(
            "Get",
            getDriverChangeParams(dateTime, deviceId, userId)
        ).then(resolve, reject);
    });
}

export function getDeviceAssignedToDriver(api: Api, userId: string): Promise<IIdEntity | null> {
    return new Promise(resolve => {
        let nowDateString = getServerDate().toISOString();
        getDriverChange(api, nowDateString, undefined, userId)
            .then(userDriverChanges => {
                let userDriverChange = userDriverChanges.length ? new DriverChangeLog(userDriverChanges[0]) : null;
                if (userDriverChange?.device) {
                    return getDriverChange(api, nowDateString, userDriverChange.device.id);
                }
                return [];
            }).then(deviceDriverChanges => {
                let deviceDriverChange = deviceDriverChanges.length ? new DriverChangeLog(deviceDriverChanges[0]) : null;
                if (deviceDriverChange && deviceDriverChange.driver.id === userId) {
                    resolve(deviceDriverChange.device);
                    return;
                }
                resolve(null);
                return;
            }).catch(() => resolve(null));
    });
}

export function getDriverChangeOfUserAssignedToDevice(api: Api, deviceId: string): Promise<DriverChangeLog[]> {
    return new Promise(resolve => {
        let nowDateString = getServerDate().toISOString();
        let deviceDriverChange: DriverChangeLog | null = null;
        getDriverChange(api, nowDateString, deviceId)
            .then(deviceDriverChanges => {
                deviceDriverChange = deviceDriverChanges.length ? new DriverChangeLog(deviceDriverChanges[0]) : null;
                if (deviceDriverChange && deviceDriverChange.driver.id !== "UnknownDriverId") {
                    return getDriverChange(api, nowDateString, undefined, deviceDriverChange.driver.id);
                }
                return [];
            }).then(userDriverChanges => {
                let userDriverChange = userDriverChanges.length ? new DriverChangeLog(userDriverChanges[0]) : null;
                if (userDriverChange && deviceDriverChange && userDriverChange.device.id !== deviceDriverChange.device.id) {
                    deviceDriverChange.driver = { id: "UnknownDriverId" };
                }
                resolve(deviceDriverChange ? [deviceDriverChange] : []);
            }).catch(() => resolve([]));
    });
}